import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { useGetNowDate } from "../../utils/useTools";
const stepper = [
  "連絡先の登録",
  "退職者との続柄の確認",
  "証明書類の添付",
  "機構へ連絡",
  "請求者の登録",
  "振込先金融機関の登録",
  "添付書類の登録",
  "本人確認の書類の添付",
  "登録内容の確認",
  "機構へ提出",
];

const getNowDate = useGetNowDate;
const nowDate = new Date(
  getNowDate().year + "/" + (getNowDate().month + 1) + "/" + getNowDate().date
);

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "title1",
    type: "lineTitle",
    lineTitle: labelids.labelid.LBLR411119_01,
  },
  {
    keyword: "retirementStaffName",
    type: "contractorAndNumber",
    contractorName: "退職者名",
    showLine: false,
  },
  {
    title: "請求者氏名（ｶﾅ）",
    keyword: "demanderNameKana",
    type: "name",
    useFurigana: true,
    hafWidth: true,
    convertToHalfwidth: true,
    requiredIcon: true,
  },
  {
    title: "請求者氏名",
    keyword: "demanderName",
    type: "name",
    onlyFullWidth: true,
    requiredIcon: true,
    helpicon: true,
    helpText: (
      <>
        退職者に代わって退職手当金の受領を希望される方の氏名を入力してください。
        <br />
        なお、外国人については、フリガナ、漢字欄ともに「カタカナ」で入力をしてください。
      </>
    ),
  },
  {
    title: "郵便番号",
    keyword: "demanderZipcode",
    requiredIcon: true,
    type: "addressSearch",
    helpicon: true,
    helpText:
      "退職者に代わって退職手当金の受領を希望される方の住所地の郵便番号を入力してください。",
  },
  {
    title: "住所",
    keyword: "address",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職者に代わって退職手当金の受領を希望される方の住所を入力してください（住民票の住所地ではありません）。",
  },
  {
    title: "生年月日",
    keyword: "demanderBirth",
    type: "date",
    minDate: new Date("1900/01/01"),
    maxDate: new Date("2099/12/31"),
    requiredIcon: true,
  },
  {
    title: "請求者連絡先",
    keyword: "tel",
    type: "phoneNum",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職者に代わって退職手当金の受領を希望される方の機構から連絡が取れる電話番号を入力してください。",
    inputProps: { maxLength: 19 },
  },
  {
    title: "メールアドレス",
    keyword: "demanderEmail",
    type: "mail",
    requiredIcon: true,
    helpicon: true,
    helpText:
      "退職者に代わって退職手当金の受領を希望される方の機構から連絡が取れるメールアドレスを入力してください。",
    inputProps: { maxLength: 255 },
  },
  {
    title: "メールアドレス（確認用）",
    keyword: "demanderEmailConfirm",
    type: "mail",
    requiredIcon: true,
    inputProps: { maxLength: 255 },
  },
];

const schema = {
  demanderNameKana: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[ｧ-ﾝｦﾞﾟ\s-]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0054E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  demanderName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  demanderZipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  address: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    validate: (data: any) => {
      let prefecturesError = "";
      let cityError = "";
      let adderssError = "";

      // 全角文字のみ
      if (data.city && !data.city.match(/^[^ -~｡-ﾟ]+$/)) {
        cityError = TkPropertyMessageGet("TKMSG_SCR0061E");
      }
      if (data.address && !data.address.match(/^[^ -~｡-ﾟ]+$/)) {
        adderssError = TkPropertyMessageGet("TKMSG_SCR0061E");
      }

      // 必須入力
      if (!data.prefectures || data.prefectures === "") {
        prefecturesError = TkPropertyMessageGet("TKMSG_SCR0043E");
      }
      if (!data.city || data.city === "") {
        cityError = TkPropertyMessageGet("TKMSG_SCR0043E");
      }
      if (!data.address || data.address === "") {
        adderssError = TkPropertyMessageGet("TKMSG_SCR0043E");
      }

      // 最大文字数
      if (data.city && data.city.length > 20) {
        cityError = TkPropertyMessageGet("TKMSG_SCR0046E", "20");
      }
      if (data.address && data.address.length > 85) {
        adderssError = TkPropertyMessageGet("TKMSG_SCR0046E", "85");
      }

      if (prefecturesError === "" && cityError === "" && adderssError === "") {
        return undefined;
      } else {
        return JSON.stringify({
          prefectures: prefecturesError,
          city: cityError,
          address: adderssError,
        });
      }
    },
  },
  demanderBirth: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxDate: {
      value: new Date(),
      message: TkPropertyMessageGet(
        "TKMSG_SCR0051E",
        nowDate.getFullYear() +
          "/" +
          (nowDate.getMonth() + 1) +
          "/" +
          nowDate.getDate
      ),
    },
    minDate: {
      value: new Date("1900/1/1"),
      message: TkPropertyMessageGet("TKMSG_SCR0050E", "1900/1/1"),
    },
  },
  tel: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 19,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "19"),
    },
  },
  demanderEmail: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
  demanderEmailConfirm: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
  },
};

export { stepper, fakeTableList, schema };
